<h1 style="text-align: center;" mat-dialog-title *ngIf="title">{{ title }}</h1>
<div style="text-align: center; white-space: pre;" mat-dialog-content [innerHtml]="message | safe:'html'"></div>
<div mat-dialog-actions class="actions" style="float: right">
	<button mat-raised-button color="warn" mat-dialog-close tabindex="0" *ngIf="showNoButton" >{{ noLabel }}</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="true">{{ yesLabel }}</button>
</div>